/**
 * Animation Disabler JavaScript
 *
 * This file defines Animation Disabler
 * behavior.
 */
import throttle from '../../util/throttle';

let timer = null;
window.addEventListener(
	'resize',
	throttle(() => {
		document.body.classList.add('ani--disable');
		clearTimeout(timer);
		timer = setTimeout(() => {
			document.body.classList.remove('ani--disable');
		}, 250);
	}, 100)
);
